/** Canonical production hostnames for Inora (browser + observability guards). */
export const INORA_PRODUCTION_HOSTNAMES = [
  "www.inora.dev",
  "inora.dev",
] as const;

export const INORA_PRODUCTION_ORIGINS = [
  "https://www.inora.dev",
  "https://inora.dev",
] as const;

export function isInoraProductionHostname(hostname: string): boolean {
  const normalized = hostname.trim().toLowerCase();
  return (INORA_PRODUCTION_HOSTNAMES as readonly string[]).includes(normalized);
}
